<div [ngClass]="{'my-2': !lastItem && firstItem === lastItem}">
  @if (document) {
    <span class="mb-0">
      {{ document.name }}
    </span>
  }
  <div ngbDropdown class="dropdown w-100 d-inline-block" ngDefaultControl>
    <button class="dropdown-toggle btn btn-sm form-control text-truncate default float-end mt-1"
      [ngClass]="{ 'invalid-outline': !NotSet }" [disabled]="disabled" type="button" id="dropdownMenu" ngbDropdownToggle>
      {{ getCheckListItemValue(document?.checklistItemId || null) }}<em class="bi bi-chevron-down float-end ms-2"
    aria-hidden="true"></em>
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownMenu" class="checklistItemDropdown">
    @for (checkListItem of checklistItems; track checkListItem) {
      <button [value]="checkListItem.checklistItemId"
        (click)="changeCheckListItem(checkListItem.checklistItemId)"
        [disabled]="disabled"
      ngbDropdownItem>{{checkListItem.checklistItemName}}</button>
    }
  </div>
</div>
</div>